var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNorthIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.99 122.88",
    style: {
      enableBackground: "new 0 0 90.99 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.96,7.65L4.59,87.23l39.37-20.97V7.65L43.96,7.65L43.96,7.65z M40.9,93.74l14.03,17.65V99.16 c0-1.73-0.24-2.89-0.74-3.49c-0.67-0.82-1.81-1.22-3.39-1.19v-0.73h9.41v0.73c-1.2,0.16-2.01,0.36-2.43,0.6 c-0.41,0.25-0.73,0.65-0.97,1.21c-0.23,0.56-0.34,1.53-0.34,2.87v23.72h-0.71L36.53,99.13v18.17c0,1.64,0.37,2.77,1.12,3.35 c0.75,0.58,1.62,0.87,2.59,0.87h0.67v0.73H30.77v-0.73c1.58-0.01,2.66-0.34,3.29-0.97c0.62-0.64,0.92-1.71,0.92-3.24V97.14 l-0.59-0.74c-0.6-0.77-1.13-1.28-1.6-1.53c-0.46-0.24-1.12-0.38-1.99-0.41v-0.73H40.9L40.9,93.74z M46.78,0.94l44.05,89.04 c0.35,0.71,0.06,1.58-0.66,1.93c-0.43,0.22-0.92,0.19-1.32-0.03v0.01L45.42,68.76L1.98,91.9L0,89.98L44.12,0.81h0.01 C44.36,0.33,44.85,0,45.42,0l0,0C46.03,0,46.56,0.37,46.78,0.94L46.78,0.94L46.78,0.94L46.78,0.94z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNorthIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/north-icon.50aec600.svg";
export { ForwardRef as ReactComponent };